import { render, staticRenderFns } from "./Predictor.vue?vue&type=template&id=2e022679&"
import script from "./Predictor.vue?vue&type=script&lang=js&"
export * from "./Predictor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports